import { atom } from 'recoil'

export const modalNoEdit = atom({
  key: 'overviewMessageModalNoEdit',
  default: false
})

export const modalConfirmCopy = atom({
  key: 'overviewMessageModalConfirmCopy',
  default: false
})

export const modalConfirmCopyHtml = atom({
  key: 'overviewMessageModalConfirmCopyHtml',
  default: false
})

export const modalDefaultFields = atom({
  key: 'overviewMessageModalDefaultFields',
  default: false
})

export const modalNotificationMessage = atom({
  key: 'overviewMessageModalNotificationMessage',
  default: {
    show: false,
    selectedMessageType: undefined,
    isEnableConfirmationRadio: false,
    isEnableWelcomeRadio: false,
    enableNotification: false
  }
})

export const modalBuyCollaboration = atom({
  key: 'overviewMessageModalBuyCollaboration',
  default: false
})

export const modalAlertMessageUpdate = atom({
  key: 'overviewModalAlertMessageUpdate',
  default: false
})

export const modalCheckup = atom({
  key: 'overviewModalCheckup',
  default: {
    show: false,
    dynamicFieldsOptionEnabled: false,
    wrongDynamicTags: [],
    checkLiquidCode: true,
    checkAttachments: true,
    checkDynamicContents: true,
    checkSize: true,
    checkBlacklistResult: true,
    checkContent: true,
    checkLinksWoTracking: true,
    checkUnsubscribeLink: true,
    checkMaxSize: true,
    checkPreheader: true,
    checkWebAnalytics: true,
    checkWorkflowWarning: false,
    addToWhiteList: [],
    silencedAlertsArray: [],
    silencedCheck: false,
    blockToDisplay: []
  }
})

export const modalConfirmChangeDefaultMessageState = atom({
  key: 'overviewModalConfirmChangeDefaultMessageState',
  default: {
    show: false,
    showInfo: false
  }
})
